import React, { Component } from 'react';
import { NavBar, BreadCumb, TimeOut, DepositModal, JournalEntryModal, PdfViewer } from '../../components';
import { DISPATCH_ID, FORMAT_NUMBER } from '../../libs/utils/Const';
import config from "../../config";
import { connect } from 'react-redux';
import '../../css/tablesPOS.css';
import moment from 'moment';
import { ApiClient } from "../../libs/apiClient";
import { GeneralFunctions } from "../../components/index";
import $ from "jquery";

let apiClient = ApiClient.getInstance();

const _generalFunctions = new GeneralFunctions();

class BankDepositsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            initialDate: moment(new Date()).format("YYYY-MM-DD"),
            finalDate: moment(new Date()).format("YYYY-MM-DD"),
            lines: [],
            depositModel: {
                amount: '',
                orginCode: '',
                originName: '',
                destinationCode: '',
                destinationName: '',
                description: '',
                originIndex: '',
                destinyIndex: '',
            },
            accumulator: 0.00,
            accounts: [],
            AvailablePayments: [],

            initialDateList: moment(new Date()).format("YYYY-MM-DD"),
            finalDateList: moment(new Date()).format("YYYY-MM-DD"),
            nroDoc: '',
            showJournalEntryModal: false,
            detailsJournalEntry: [],

            showPDFViewer: false,
            printhide: true,
            docsToPrint: [],
            typeDocPrint: '',

            sendMailModel: {
                to: '',
                subject: '',
                docEntry: ''
            },
            comments: '',
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        };
    }

    componentDidMount = async () => {
        await this.GetDestinationAccounts();
        await this.SetBranchOfficeInfo();
    };

    SetBranchOfficeInfo = () => {
        const { _user } = this.state
        this.setState({
            AvailablePayments: _user?.Branch.PaymentMethods || [],
        })
    }

    GetDestinationAccounts = async () => {
        const { enableSpinner } = this.props;
        enableSpinner(true)
        let responseApi = await apiClient.getDestinationAccounts();
        enableSpinner(false);
        this.setState({ accounts: responseApi.data || [] })
    }

    RefreshModel = async (depositModel) => {
        await this.setState({ depositModel });
    }

    CleanForm = () => {
        this.setState({
            depositModel: {
                amount: '',
                orginCode: '',
                originName: '',
                destinationCode: '',
                destinationName: '',
                description: '',
                originIndex: '',
                destinyIndex: '',
            },
        })
    }

    ValidateAddedLine = () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { depositModel } = this.state
        if (depositModel.amount === 0 || depositModel.amount === '') {
            showAlert({ type: "error", message: `NO PUEDES DEJAR EL MONTO EN 0 Ó VACIÓ` });
            return false
        }
        if (depositModel.typePay === '') {
            showAlert({ type: "error", message: `NO HAS SELECCIONADO UN TIPO DE PAGO` });
            return false
        }
        if (depositModel.destinationCode === '') {
            showAlert({ type: "error", message: `NO HAS SELECCIONADO EL DESTINO` });
            return false
        }
        if (depositModel.description === '') {
            showAlert({ type: "error", message: `NO HAS COMPLETADO EL CAMPO DE DESCRIPCIÓN` });
            return false
        }
        return true;

    }

    AddToLines = async () => {
        const { lines, depositModel } = this.state
        if (this.ValidateAddedLine()) {
            $("#depositModal").modal("hide");
            let newLines = lines;
            let newDepositModel = depositModel;
            newLines.push(newDepositModel);
            await this.setState({ lines: newLines })
            await this.CalculateAccumulator();

            setTimeout(() => {
                this.CleanForm()
            }, 100)

        }
    }

    CalculateAccumulator = async () => {
        const { lines } = this.state
        let acum = 0;
        if (Array.isArray(lines) && lines.length > 0) {
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i];
                acum = acum + Number(line.amount);
            }
        }
        await this.setState({ accumulator: acum })

    }

    ValidateJournalEntry = () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { lines } = this.state
        if (lines.length === 0) {
            showAlert({ type: "error", message: `NO HAS AGREGADO NINGÚN DEPÓSITO AÚN` });
            return false
        }
        return true
    }

    DeleteLine = async (index) => {
        const { lines } = this.state
        lines.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        this.setState({ lines })
        await this.CalculateAccumulator();
    }

    GenerateJournalEntry = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { lines, comments } = this.state
        if (await this.ValidateJournalEntry()) {
            const data = {
                Lines: lines,
                CommentMemo: comments
            }

            enableSpinner(true);
            const responseApi = await apiClient.generateJournalEntry(data);
            enableSpinner(false);

            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: responseApi.message });
                return;
            }

            if (responseApi.data && responseApi.data.auxErrors.length > 0) {
                showAlert({ type: "info", message: responseApi.message, timeOut: 5000 });
                showAlert({ type: "info", message: `SE ELIMINARAN LAS LINEAS QUE SE INSERTARON CORRECTAMENTE`, timeOut: 5000 });
               
             
                for (let index = 0; index < responseApi.data.auxSucess.length; index++) {
                    const successLine = responseApi.data.auxSucess[index];
                    lines[successLine.index] = null;
                }

                for (let index = 0; index < responseApi.data.auxErrors.length; index++) {
                    const errorLine = responseApi.data.auxErrors[index];
                    showAlert({ type: "error", message: `Error en linea ${errorLine.index}. Error: ${errorLine.errorMessage}`, timeOut: 5000 });
                }
                await this.setState({
                    lines: lines.filter(line => line !== null),

                })
            } else {
                showAlert({ type: "success", message: responseApi.message, timeOut: 5000 });
                await this.setState({
                    lines: [],
                    accumulator: 0.00,
                    depositModel: {
                        amount: '',
                        orginCode: '',
                        originName: '',
                        destinationCode: '',
                        destinationName: '',
                        description: '',
                        originIndex: '',
                        destinyIndex: '',
                    },
                    comments: ''
                })
            }
        }
    }

    ChangeInitialDateList = async (event) => {
        let initialDateList = event.nativeEvent.target.value;
        await this.setState({ initialDateList });
    };

    ChangeFinalDateList = async (event) => {
        let finalDateList = event.nativeEvent.target.value;
        await this.setState({ finalDateList });
    };

    ChangeNroDoc = event => {
        let valor = event.nativeEvent.target.value;
        this.setState({
            nroDoc: valor
        });
    };

    ListJournalEntry = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { initialDateList, finalDateList, nroDoc } = this.state;
        enableSpinner(true);

        let responseJournalEntry = await apiClient.getJournalEntry(initialDateList, finalDateList, nroDoc ? nroDoc : null);
        enableSpinner(false);
        if (responseJournalEntry.status === 0) {
            if (!Array.isArray(responseJournalEntry.data.results)) {
                showAlert({ type: 'info', message: responseJournalEntry.message });
                this.setState({
                    listJournalEntry: []
                })
                return;
            }
            if (responseJournalEntry.data.results.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                this.setState({
                    listJournalEntry: []
                })
                return;
            }
        }
        this.setState({
            listJournalEntry: responseJournalEntry.data ? responseJournalEntry.data : [],
            nroDoc: ''
        });
    };

    CloseJournalEntryModal = async () => {
        $('#journalEntryModal').modal('hide');

        await this.setState({
            showJournalEntryModal: !this.state.showJournalEntryModal,
        });
    };

    SearchJournalEntry = async filter => {
        await this.callJournalEntry(filter);
    };

    callJournalEntry = async (id) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);

        let getOneJournalEntry = await apiClient.getOneJournalEntry(id);

        if (getOneJournalEntry.status === 1) {
            this.setState({
                detailsJournalEntry: getOneJournalEntry.data,
                showJournalEntryModal: !this.state.showJournalEntryModal,
            });
            $('#journalEntryModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        } else {
            showAlert({ type: 'warning', message: 'No se encontraron registros coincidentes', timeOut: 5000 });
        }
        enableSpinner(false);
    };

    EnablePDFViewer = async () => {
        await this.setState({
            showPDFViewer: !this.state.showPDFViewer
        })
    }

    PrintBankDeposit = async (value) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        await this.EnablePDFViewer();
        const data = {
            docsToPrintIds: [value],
            typeDoc: 30
        }
        enableSpinner(true);
        const responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: responseApi.message });
            return;
        }

        await this.setState({
            typeDocPrint: 'OJDT',
            docsToPrint: [responseApi.data[0]]
        })
        $("#pdfViewer").modal("show");
    }
    //#region ########## MAIL FUNCTIONS  #################################################

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async (docsStruct) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDocPrint } = this.state
        let infoFolio = await _generalFunctions.getDocInfoByFolio(docsToPrint[0].docHeader.infoByFolio.folio ?? '')
        sendMailModel.docEntry = infoFolio.DocEntry
        const data = {
            sendMailModel,
            typeDoc: typeDocPrint,
            objType: infoFolio.num,
            infoDoc: [{
                cardCode: docsToPrint[0].docHeader.responseHeader.CardCode ?? '',
                folio: docsToPrint[0].docHeader.infoByFolio.folio ?? ''
            }]
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    }
    //#endregion

    ShowFormatToPrint = async () => {
        await this.setState({
            printhide: !this.state.printhide,
        });
    };

    ChangeCreditMemo = async (value) => {
        await this.setState({
            comments: value
        })
    };

    render() {

        const {
            AvailablePayments,
            depositModel, lines, accounts,
            accumulator, initialDateList, finalDateList,
            nroDoc, listJournalEntry, showJournalEntryModal,
            detailsJournalEntry, showPDFViewer, docsToPrint,
            typeDocPrint, _user, sendMailModel, printhide, comments
        } = this.state
        AvailablePayments.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));

        const depositTools = {
            depositModel: depositModel,
            accounts: accounts,
            AvailablePayments: AvailablePayments,
            RefreshModel: this.RefreshModel,
            AddToLines: this.AddToLines,
            CleanForm: this.CleanForm
        }

        const mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={true} _user={_user}/>
                <TimeOut />
                <BreadCumb subitem1={'DEPÓSITOS'} url1={'#'} />
                <div style={{ marginLeft: "4rem" }}>
                    <div className="row m-3">
                        <h3 className="ml-3 mb-2 mt-3">Depósitos bancarios</h3>
                    </div>
                    <div className='m-3'>
                        <nav className='mt-4 ml-3' >
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary active"}
                                    id="nav-home-tab-Depositos"
                                    data-toggle="tab"
                                    href="#dataDepositosBancarios"
                                    role="tab"
                                    aria-controls="dataDepositosBancarios"
                                    aria-selected="true">
                                    Depositar
                                </a>
                                <a
                                    className={"nav-item nav-link font-weight-bold text-secondary"}
                                    id="nav-profile-tab-List"
                                    data-toggle="tab"
                                    href="#dataListDepositosBancarios"
                                    role="tab"
                                    aria-controls="dataListDepositosBancarios"
                                    aria-selected="false">
                                    Listar depósitos
                                </a>
                            </div>
                        </nav>
                        <div className="tab-content pl-3" style={{ textAlign: 'left' }}>
                            <div
                                className="w-100 table-scroll tab-pane active"
                                id="dataDepositosBancarios"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab-Depositos"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>
                                <div className="row m-3 row-responsive">
                                    <div className="col-xl-12 mb-4 mb-xl-0">
                                        <div className="row p-3">
                                            <div className="col-12 col-md-3">
                                            </div>
                                            <div className="col-12 col-md-3">
                                            </div>
                                            <div className="col-12 col-md-3" >
                                            </div>
                                            <div className="col-12 col-md-3 text-right" >
                                                <button type="button" className="btn btn-outline-success mr-2" data-toggle="modal" data-target="#depositModal">
                                                    <i className="fa fa-plus-circle mr-2" aria-hidden="true" />
                                                    Nuevo Depósito
                                                </button>
                                                <button type="button" className="btn btn-outline-primary" onClick={() => this.GenerateJournalEntry()}>
                                                    <i className="fa fa-upload mr-2" aria-hidden="true" />
                                                    Generar
                                                </button>
                                            </div>
                                        </div>
                                        <div className='card scrollTableDeposit' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: 'white' }}>
                                                    <tr>
                                                        <th className="text-center">Index</th>
                                                        <th className="text-center">Forma de pago</th>
                                                        <th className="text-center">Cuenta destino</th>
                                                        <th className="text-center">Comentario</th>
                                                        <th className="text-center">Monto</th>
                                                        <th className="text-center">Depósito real</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {lines.length > 0 &&
                                                        lines.map((line, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td className="text-center">{index}</td>
                                                                    <td className="text-center">{line.orginCode}.- {line.originName}</td>
                                                                    <td className="text-center">{line.destinationCode}.- {line.destinationName}</td>

                                                                    <td className="text-center">{line.description}</td>

                                                                    <td className="text-center">{FORMAT_NUMBER.new(line.amount)}</td>
                                                                    <td className="text-center">{FORMAT_NUMBER.new(line.amount)}</td>
                                                                    <td className="text-center" style={{ color: "#dc3545" }} onClick={() => this.DeleteLine(index)}>
                                                                        <i className="fa fa-trash-o cursor-pointer" />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    }

                                                    <tr className='noSearch hide'>
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-12 col-md-7"></div>
                                            <div className="col-12 col-md-5 text-right">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Comentarios</strong></span>
                                                    </div>
                                                    <input
                                                        maxLength="50"
                                                        type="text"
                                                        className="form-control text-right"
                                                        value={comments}
                                                        onChange={(event) => this.ChangeCreditMemo(event.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-md-9">
                                            </div>
                                            <div className="col-12 col-md-3 text-right">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Total</strong></span>
                                                    </div>
                                                    <input type="text" className="form-control text-right" disabled placeholder={FORMAT_NUMBER.new(accumulator)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="w-100 tab-pane"
                                id="dataListDepositosBancarios"
                                role="tabpanel"
                                aria-labelledby="nav-profile-tab-List"
                                style={{ paddingTop: 5, border: "1px solid #00000020", borderTop: "none", borderRadius: "0.25rem" }}>

                                <div className="row m-3 row-responsive">
                                    <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                                        <div className="row p-3">
                                            <div className="col-12 col-md-3 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Desde: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date" className="form-control"
                                                        onKeyPress={(ev) => { if (ev.key === 'Enter') { this.ListJournalEntry() } }}
                                                        value={initialDateList}
                                                        max='9999-12-31'
                                                        onChange={(event) => this.ChangeInitialDateList(event)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Hasta: </strong></span>
                                                    </div>
                                                    <input
                                                        type="date" className="form-control"
                                                        onKeyPress={(ev) => { if (ev.key === 'Enter') { this.ListJournalEntry() } }}
                                                        onChange={(event) => this.ChangeFinalDateList(event)}
                                                        max='9999-12-31'
                                                        value={finalDateList}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3 mb-2">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text" id="basic-addon1"><strong>Folio</strong></span>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        // placeholder="" 
                                                        id="NroDocumento"
                                                        onChange={this.ChangeNroDoc}
                                                        value={nroDoc ? nroDoc : ''}
                                                        onKeyPress={(ev) => { if (ev.key === 'Enter') { this.ListJournalEntry(); } }}
                                                    />
                                                    <div className="input-group-append">
                                                        <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#afafaf', borderLeft: "none" }} /*onClick={() =>this.ListJournalEntry()}*/>
                                                            <i className="fa fa-search" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-1 text-left">
                                                <button className="btn btn-active" onClick={() => this.ListJournalEntry()}
                                                    style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className='card scrollTableListDeposit mb-3' >
                                            <table className="table table-striped table-hover" id="inData" >
                                                <thead className='sticky-headerPOS' style={{ backgroundColor: 'white' }}>
                                                    <tr>
                                                        <th className="text-center">Folio</th>
                                                        <th className="text-center">Fecha contabilización</th>
                                                        <th className="text-center">Fecha vencimiento</th>
                                                        <th className="text-center">Fecha documento</th>
                                                        <th className="text-center">Comentarios</th>
                                                        <th></th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!listJournalEntry && listJournalEntry.map((journal, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td className="text-center">{journal.uniqueIdREJE || ''}</td>
                                                                <td className="text-center">{moment(journal.RefDate).utc().format("DD-MM-YYYY")}</td>
                                                                <td className="text-center">{moment(journal.DueDate).utc().format("DD-MM-YYYY")}</td>
                                                                <td className="text-center">{moment(journal.TaxDate).utc().format("DD-MM-YYYY")}</td>
                                                                <td className="text-center">{journal.comment}</td>
                                                                <td className="sticky-column">
                                                                    <button type="button" className="btn botonCorrect"
                                                                        onClick={() => this.SearchJournalEntry(journal.uniqueIdREJE)}>
                                                                        Ver
                                                                    </button>
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        className='btn btn-primary'
                                                                        style={{
                                                                            backgroundColor: "rgb(233, 236, 239)",
                                                                            color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)"
                                                                        }}
                                                                        onClick={() => this.PrintBankDeposit(journal.uniqueIdREJE)}>
                                                                        <i className="fa fa-print" aria-hidden="true"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                    }

                                                    <tr className='noSearch hide'>
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <DepositModal
                    DepositTools={depositTools}
                />
                {showJournalEntryModal &&
                    <JournalEntryModal
                        detailsJournalEntry={detailsJournalEntry}
                        CloseJournalEntryModal={this.CloseJournalEntryModal}
                    />
                }
                {showPDFViewer &&
                    <PdfViewer
                        DocsToPrint={docsToPrint}
                        TypeDoc={typeDocPrint}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={() => { }}
                        EditableDocModel={{}}
                        RefreshDocModel={() => { }}
                        SaveChanges={()=>{}}
                        UploadDoc={() => { }}
                        EditParam1={false}
                        ShowPDFViewer={this.EnablePDFViewer}
                        CreateDocument={this.CreateDocument}
                        OpenMailModal={this.OpenSendMailModal}
                        ItsFirme={true}
                        user={_user}
                        Counter={true}
                        MailTools={mailTools}
                        ExtraDocsToShow={[]}
                        ShowNextDocument={this.ShowNextDocument}
                        ShowExtraActions={false}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                        reprint={false}
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BankDepositsView);
